var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000034060562110061399050000013967297211084660365_);}\r\n\t.st3{fill:#000000;}\r\n\t.st4{clip-path:url(#SVGID_00000034073520837903416310000005960606205149984184_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091702310286062065930000000752653807218262151_",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091702310286062065930000000752653807218262151_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0      s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3      s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2      s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2      S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2      s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2      s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z",
    fill: "#000000"
  })))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158714002899700513940000014483333500358495924_",
    x: 7.7,
    y: 8.2,
    width: 87.7,
    height: 87.7,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153685474408848879800000014005718958739750016_",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158714002899700513940000014483333500358495924_",
    style: {
      overflow: "visible"
    },
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153685474408848879800000014005718958739750016_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,37.4c-2.1,0-4.1-0.8-5.7-2.2c-3.4-3.1-5.4-7.4-5.7-11.9c-0.9-9.1,4.1-14.5,9.4-15.1c1.3-0.1,2.6,0,3.9,0.3    c1.2,0.4,2.4,1,3.4,1.8c1.5,1.3,2.7,3,3.6,4.8c0.8,1.8,1.4,3.8,1.5,5.8C48.6,29.5,44.7,37.4,37.5,37.4z M36.3,15.5    c-2.1,0.2-3.4,3.2-3,7.1c0.1,2.6,1.2,5.1,3,6.9c0.3,0.3,0.8,0.5,1.3,0.6c1.3-0.1,3.4-3.4,2.8-8.4C39.2,14.9,36.4,15.5,36.3,15.5    L36.3,15.5z M19.2,59.4c-2.1,0-4.1-0.8-5.7-2.2c-3.4-3.1-5.4-7.4-5.7-11.9c-0.9-9.1,4.1-14.5,9.4-15.1c1.3-0.1,2.6,0,3.9,0.4    c1.2,0.4,2.4,1,3.4,1.8c1.5,1.3,2.7,3,3.6,4.8c0.8,1.8,1.4,3.8,1.5,5.8C30.3,51.4,26.2,59.4,19.2,59.4z M18,37.4    c-2.1,0.2-3.4,3.2-3,7.1c0.1,2.6,1.2,5.1,3,6.9c0.3,0.3,0.8,0.5,1.3,0.6c1.3-0.1,3.4-3.4,2.8-8.4C21.3,37,18.1,37.4,18,37.4    L18,37.4z M65.5,37.4c-6.2,0-11.1-7.9-10.3-16.4c0.1-2,0.6-4,1.5-5.8c0.8-1.8,2.1-3.4,3.6-4.8c1-0.8,2.2-1.4,3.4-1.8    c1.2-0.4,2.5-0.5,3.8-0.3c5.4,0.6,10.3,6,9.4,15.1c-0.3,4.6-2.3,8.8-5.7,11.9C69.7,36.6,67.6,37.4,65.5,37.4z M62.5,21.7    c-0.5,4.9,1.6,8.2,2.8,8.4c0.5,0,0.9-0.2,1.3-0.5c1.8-1.9,2.9-4.3,3-6.9C70.5,13.1,63.2,13.7,62.5,21.7z M83.8,59.4    c-6.8,0-11.1-7.9-10.3-16.4c0.1-2,0.6-4,1.5-5.8c0.8-1.8,2.1-3.4,3.6-4.8c1-0.8,2.2-1.4,3.4-1.8c1.2-0.4,2.5-0.5,3.8-0.4    c5.4,0.6,10.3,6,9.4,15.1c-0.3,4.6-2.3,8.8-5.7,11.9C87.9,58.6,85.9,59.3,83.8,59.4z M80.8,43.7c-0.5,4.9,1.6,8.2,2.8,8.4    c0.5,0,0.9-0.2,1.3-0.5c1.8-1.9,2.9-4.3,3-6.9c0.4-3.9-0.9-6.9-3-7.1C84.9,37.4,81.2,37.1,80.8,43.7z M66.1,95.9    c-3.1,0.1-6.2-0.7-8.9-2.2c-1.8-0.9-3.7-1.4-5.7-1.4s-3.9,0.5-5.7,1.4c-11,6.2-23.9-0.6-23.6-16.1c0-16.9,16.5-32.9,29.2-32.9    s29.2,15.9,29.2,32.9C80.7,88.4,74.7,95.9,66.1,95.9z M51.5,84.9c3.1-0.1,6.2,0.7,8.9,2.2c8.1,4.4,13.1-1.6,13-9.5    c0-12.3-12.9-25.6-21.9-25.6S29.6,65.3,29.6,77.6c-0.1,7.9,4.8,14,13,9.5C45.3,85.6,48.4,84.9,51.5,84.9z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimal);
export default __webpack_public_path__ + "static/media/Animal.e533182fbde69dbff8d54dedbbec3b72.svg";
export { ForwardRef as ReactComponent };